import { useEffect, useState } from "react";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { IPlannerEventUserModel } from "../models/plannerEventUserModel";

/** The reservation's "Флаг" toggle: flags the client for every class with this name. */
export const usePlannerEventReservationDetailsFlag = (
  user: IPlannerEventUserModel,
) => {
  const { mutateAsync } = useApiMutation();
  const [isSaving, setIsSaving] = useState(false);
  // The position just chosen, held until the reloaded class shows it, so the toggle doesn't
  // flip back to the old value in between.
  const [pendingFlag, setPendingFlag] = useState<boolean>();
  const savedFlag = !!user.hasClassFlag;

  useEffect(() => {
    if (pendingFlag === savedFlag) {
      setPendingFlag(undefined);
    }
  }, [pendingFlag, savedFlag]);

  const onFlagChange = async (isFlagged: boolean) => {
    setIsSaving(true);
    setPendingFlag(isFlagged);
    try {
      await mutateAsync(
        {
          endpoint: endpointsMetadata.classFlag.setClassFlag,
          method: "put",
          payload: { userEventId: user.userEventId, isFlagged },
          globalIsLoading: false,
          invalidateKeys: [[endpointsMetadata.planner.getEvent]],
        },
        { onSettled: () => setIsSaving(false) },
      );
    } catch {
      // already shown by useApiMutation
      setPendingFlag(undefined);
    }
  };

  return { isFlagged: pendingFlag ?? savedFlag, isSaving, onFlagChange };
};
